import { Children, type ReactElement, type ReactNode } from 'react';

export interface IntegrationSectionProps {
  title: string;
  subtitle: string;
  children?: ReactNode;
}

function countNonNullChildren(children: ReactNode): number {
  return Children.toArray(children).filter(Boolean).length;
}

export function IntegrationSection(
  props: IntegrationSectionProps
): ReactElement | null {
  const { title, subtitle, children } = props;
  if (countNonNullChildren(children) === 0) return null;
  return (
    <section data-testid="integration-section" className="flex flex-col">
      <div data-testid="integration-section-header" className="mb-4">
        <h3
          data-testid="integration-section-title"
          className="m-0 text-base font-semibold leading-6 text-foreground"
        >
          {title}
        </h3>
        <p
          data-testid="integration-section-subtitle"
          className="mx-0 mb-0 mt-1 text-[13px] leading-[19.5px] text-muted-foreground"
        >
          {subtitle}
        </p>
      </div>
      <div
        data-testid="integration-section-grid"
        className="grid grid-cols-2 gap-4"
      >
        {children}
      </div>
    </section>
  );
}
IntegrationSection.displayName = 'IntegrationSection';
